import { StepsEnum } from './enum'
import React from 'react';

export const typesListArray = [
    {
        value: 'universal_module',
        label: 'Универсальный модуль'
    },
    {
        value: 'physical_culture',
        label: 'Физическая культура'
    },
    {
        value: 'philosophy_thinking',
        label: 'Модуль «Философия+Мышление»'
    },
    {
        value: 'digital_culture',
        label: 'Цифровая культура'
    },
    {
        value: 'entrepreneurial_culture',
        label: 'Предпринимательская культура'
    },
    {
        value: 'soft_skills',
        label: 'Soft Skills'
    },
    {
        value: 'ognp',
        label: 'ОГНП'
    },
    {
        value: 'natural_science_module',
        label: 'Естественнонаучный модуль'
    },
    {
        value: 'general_professional_module',
        label: 'Общепрофессиональный модуль'
    },
    {
        value: 'elective_module',
        label: 'Элективный модуль по группе направлений'
    },
    {
        value: 'interdisciplinary_module_of_the_faculty',
        label: ' Межпрофильный модуль факультета'
    },
    {
        value: 'faculty_module',
        label: 'Факультетский модуль'
    },
    {
        value: 'profile_professional_module',
        label: 'Профильный профессиональный модуль'
    },
    {
        value: 'math_module',
        label: 'Математический модуль'
    },
    {
        value: 'digital_culture_in_professional_activities',
        label: 'Цифровая культура в профессиональной деятельности'
    },
    {
        value: 'specialization_module',
        label: 'Модуль специализации'
    },
    {
        value: 'gia',
        label: 'Гиа'
    },
    {
        value: 'practice',
        label: 'Практика'
    },
    {
        value: 'optional_disciplines',
        label: 'Факультативные дисциплины'
    }
];

export const typesListArrayNew = [
    {
        value: 'universal_module',
        label: 'Универсальный модуль'
    },
    {
        value: 'faculty_module',
        label: 'Факультетский (обычный)'
    },
];

export const typesListObject = {
    universal_module: 'Универсальный модуль',
    physical_culture: 'Физическая культура',
    philosophy_thinking: 'Модуль «Философия+Мышление»',
    digital_culture: 'Цифровая культура',
    entrepreneurial_culture: 'Предпринимательская культура',
    soft_skills: 'Soft Skills',
    ognp: 'ОГНП',
    natural_science_module: 'Естественнонаучный модуль',
    general_professional_module: 'Общепрофессиональный модуль',
    elective_module: 'Элективный модуль по группе направлений',
    interdisciplinary_module_of_the_faculty: 'Межпрофильный модуль факультета',
    faculty_module: 'Факультетский модуль',
    profile_professional_module: 'Профильный профессиональный модуль',
    math_module: 'Математический модуль',
    digital_culture_in_professional_activities: 'Цифровая культура в профессиональной деятельности',
    specialization_module: 'Модуль специализации',
    gia: 'Гиа',
    practice: 'Практика',
    optional_disciplines: 'Факультативные дисциплины',
};

export const steps = {
    [StepsEnum.GENERAL]: 'Главная',
    [StepsEnum.MODULES]: 'Учебные модули',
    [StepsEnum.PLANS]: 'Доступные учебные планы',
    [StepsEnum.EVALUATION_TOOLS]: <>Оценочные средства <br /> (не обязательны)</>,
    [StepsEnum.PLANS_WITH_MODULE_DATA]: 'Планы с данным модулем',
    [StepsEnum.MODULE_COPY_HISTORY]: 'История копирования модуля',
}

export const selectRulesArray = [
    {
        value: 'choose_n_from_m',
        label: 'Выбрать количество дисциплин/модулей'
    },
    {
        value: 'all',
        label: 'Необходимо выбрать всё в модуле'
    },
    // {
    //     value: 'any_quantity',
    //     label: 'Выбрать в модуле любое количество или 0'
    // },
    {
        value: 'by_credit_units',
        label: 'Необходимое количество зачетных единиц'
    },
    // {
    //     value: 'no_more_than_n_credits',
    //     label: 'Hе более N зачетных единиц'
    // },
]


export const statusPlansIncluded: any = {
    verified: "Принято",
    on_check: "На проверке",
    in_work: "В работе"
}

export const statusTrainingModule: any = {
    used: "Используется",
    not_used: "Не используется"
}
